export async function sha256(input: string): Promise<string> {
    // Chuyển đổi chuỗi đầu vào sang dạng ArrayBuffer
    const buffer = new TextEncoder().encode(input);

    // Tạo một mã hóa SHA-256
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);

    // Chuyển đổi kết quả từ ArrayBuffer sang dạng chuỗi hex
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');

    return hashHex;
}